export default "/corgi/pageapps/purchase/_next/static/media/arrow-right-gray.65dc44a0.svg";